import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../features/user/userSlice";
import { Menu, X } from "lucide-react";
import LogoTitle from "./logoTitle";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    sessionStorage.removeItem("userDetail");
    navigate("/");
    setMenuOpen(false);
  };

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const desktopLinkClass = ({ isActive }) =>
    `relative transition pb-1
    ${
      isActive
        ? "text-blue-700 after:absolute after:left-0 after:bottom-0 after:w-full after:h-0.5 after:bg-blue-600"
        : "text-gray-800 hover:text-blue-700"
    }`;

  const mobileLinkClass = ({ isActive }) =>
    `w-full text-center py-2 rounded-md transition
    ${
      isActive
        ? "bg-blue-100 text-blue-700 font-semibold"
        : "text-gray-800 hover:bg-blue-50 hover:text-blue-700"
    }`;

  return (
    <header className="sticky top-0 z-50 background-theme-color shadow-md">
      <nav className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <LogoTitle />

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-10 font-medium text-gray-800">
          <li>
            <NavLink to="/" className={desktopLinkClass}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/about-us" className={desktopLinkClass}>
              About Us
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" className={desktopLinkClass}>
              Contact Us
            </NavLink>
          </li>
          <li>
            <NavLink to="/pricing" className={desktopLinkClass}>
              Pricing
            </NavLink>
          </li>

          {user ? (
            <>
              <li>
                <NavLink to="/dashboard" className={desktopLinkClass}>
                  Dashboard
                </NavLink>
              </li>
              <li>
                <NavLink to="/profile" className={desktopLinkClass}>
                  Profile
                </NavLink>
              </li>
              <li>
                <button
                  onClick={handleLogout}
                  className="text-red-500 hover:text-red-600 transition"
                >
                  Sign Out
                </button>
              </li>
            </>
          ) : (
            <li>
              <NavLink to="/login" className={desktopLinkClass}>
                Login
              </NavLink>
            </li>
          )}
        </ul>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          aria-label="Toggle menu"
          className="md:hidden text-gray-800"
        >
          {menuOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-lg">
          <ul className="flex flex-col items-center py-4 gap-4 text-gray-800 font-medium">
            <li>
              <NavLink
                to="/"
                onClick={() => setMenuOpen(false)}
                className={mobileLinkClass}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about-us"
                onClick={() => setMenuOpen(false)}
                className={mobileLinkClass}
              >
                About Us
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                onClick={() => setMenuOpen(false)}
                className={mobileLinkClass}
              >
                Contact Us
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/pricing"
                onClick={() => setMenuOpen(false)}
                className={mobileLinkClass}
              >
                Pricing
              </NavLink>
            </li>

            {user ? (
              <>
                <li>
                  <NavLink
                    to="/dashboard"
                    onClick={() => setMenuOpen(false)}
                    className={mobileLinkClass}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/profile"
                    onClick={() => setMenuOpen(false)}
                    className={mobileLinkClass}
                  >
                    Profile
                  </NavLink>
                </li>
                <li>
                  <button
                    onClick={handleLogout}
                    className="text-red-500 hover:text-red-600 transition"
                  >
                    Sign Out
                  </button>
                </li>
              </>
            ) : (
              <li>
                <NavLink
                  to="/login"
                  onClick={() => setMenuOpen(false)}
                  className={mobileLinkClass}
                >
                  Login
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
